import axios from 'axios';

const getCoverPresenceByMediaId= (mediaId: number) => axios.get(`medias/${mediaId}/cover-presences`);

export default { 
    getCoverPresenceByMediaId
};